import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import formatPriceToFloat from '../../../utils/price/format-price-to-float';

export default function useHasSelectedPaymentMethod () {
    const {
        activePaymentOption,
        formSubmitAttempt,
        paymentCart
    } = useSelector((state: RootState) => state.payment);
    const [hasSelectedPaymentMethod, setHasSelectedPaymentMethod] = useState(true);

    useEffect(() => {
        if (!formSubmitAttempt || !paymentCart?.loaded) {
            return;
        }

        setHasSelectedPaymentMethod(Boolean(activePaymentOption?.id || (formatPriceToFloat(paymentCart?.finalPrice) || 0) === 0));
    }, [formSubmitAttempt, activePaymentOption?.id, paymentCart?.loaded]);

    return hasSelectedPaymentMethod;
};
